<template>
  <section class="lg:px-8 px-4 mb-6">
    <slot />
  </section>
</template>
